import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/icons/Group 1.svg";
import { ReactComponent as Menu } from "../../assets/icons/menu-24px.svg";
import { ReactComponent as Cross } from "../../assets/icons/close-24px.svg";

import { loginPage } from "../../Redux/Actions/Authentication";
import { connect } from "react-redux";
import { HeaderLink, headerLinksTexts } from "./Header";
const InnerHeader = ({ isLogin, loginOpen }) => {
  const history = useHistory();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [menuOpen, setMenuOpen] = useState(false);
  const headerData = isLogin
    ? headerLinksTexts
    : headerLinksTexts.filter(i => !i.isPrivate);
  return (
    <>
      {!isTabletOrMobile ? (
        <div className="innerHeaderLinksDiv" id="InnerHeader">
          {!isLogin && (
            <div className="signInBtn" onClick={loginOpen}>
              ورود/ثبت نام
            </div>
          )}
          <div className="headerLinks">
            {headerData.map((i, index) => {
              return (
                <HeaderLink
                  text={i.text}
                  history={history}
                  companyId={i.companyId}
                  path={i.path}
                  selected={i.path && history.location.pathname === i.path}
                  key={`#header${index}`}
                />
              );
            })}
            <Logo />
          </div>
        </div>
      ) : (
        <div className={"paymentHeader"}>
          <Logo width={30} height={30} />
          {!menuOpen ? (
            <Menu
              fill={"#ec4d11"}
              width={40}
              height={40}
              onClick={() => setMenuOpen(!menuOpen)}
            />
          ) : (
            <Cross
              onClick={() => setMenuOpen(!menuOpen)}
              fill={"#ec4d11"}
              width={40}
              height={40}
            />
          )}
          {menuOpen && (
            <div className="headerMenu" onClick={() => setMenuOpen(false)}>
              <img
                src={require("../../assets/images/Path 1121.png")}
                alt={""}
              />
              <div>
                {headerData.map((i, index) => (
                  <HeaderLink
                    text={i.text}
                    companyId={i.companyId}
                    selected={false}
                    history={history}
                    path={i.path}
                    key={`#header${index}`}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
const mapDispatchToProps = dispatch => ({
  loginOpen: () => dispatch(loginPage(true))
});
export default connect(null, mapDispatchToProps)(InnerHeader);
